export function buildRoleClientBase(role, client) {
  if (!role || !client) return "";
  return `/${String(role).toLowerCase()}-${String(client).toLowerCase()}`;
}

export function buildRoutePath({ path, client, role, openAccess = false }) {
  const normalized = String(path).replace(/^\/+/, "");
  if (openAccess) return `/${normalized}`;
  const base = buildRoleClientBase(role, client);
  return base ? `${base}/${normalized}` : `/${normalized}`;
}

export function resolveRoute(route, { client, role } = {}) {
  if (!route) return "/";
  const routeObj = typeof route === "string" ? { path: route } : route;
  return buildRoutePath({
    path: routeObj.path,
    client,
    role,
    openAccess: routeObj.openAccess,
  });
}
